var _defs, _circle, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorAlertAnimatedTres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "failureAnimation",
    className: "animated",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.2 144.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t.cls-1, .cls-2 {\r\n\t\t\t\tfill: none;\r\n\t\t\t\tstroke: #d32f2f;\r\n\t\t\t\tstroke-width: 7px;\r\n\t\t\t\tstroke-linecap: round;\r\n\t\t\t}\r\n\t\t\t\t\r\n\t\t\t@keyframes scaleAnimation {\r\n\t\t\t\t0% {\r\n\t\t\t\t\topacity: 0;\r\n\t\t\t\t\ttransform: scale(1.5);\r\n\t\t\t\t}\r\n\t\r\n\t\t\t\t100% {\r\n\t\t\t\t\topacity: 1;\r\n\t\t\t\t\ttransform: scale(1);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\r\n\t\t\t@keyframes drawCircle {\r\n\t\t\t\t0% {\r\n\t\t\t\t\tstroke-dashoffset: 500px;\r\n\t\t\t\t}\r\n\t\r\n\t\t\t\t100% {\r\n\t\t\t\t\tstroke-dashoffset: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\r\n\t\t\t@keyframes drawLine {\r\n\t\t\t\tfrom {\r\n\t\t\t\t\tstroke-dashoffset: 100;\r\n\t\t\t\t}\r\n\t\t\t\tto {\r\n\t\t\t\t\tstroke-dashoffset: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\r\n\t\t\t#failureAnimationCircle {\r\n\t\t\t\tstroke-dasharray: 500px 500px;\r\n\t\t\t}\r\n\t\r\n\t\t\t#failureAnimation.animated {\r\n\t\t\t\tanimation: 1s ease-out 0s 1 both scaleAnimation;\r\n\t\t\t}\r\n\t\r\n\t\t\t#failureAnimation.animated #failureAnimationCircle {\r\n\t\t\t\tanimation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle;\r\n\t\t\t}\r\n\t\r\n\t\t\t.cls-2 {\r\n\t\t\t\tstroke-dasharray: 100;\r\n\t\t\t\tstroke-dashoffset: 100;\r\n\t\t\t\tanimation: drawLine 1s cubic-bezier(1, 0.2, 0.1, 1) forwards;\r\n\t\t\t}\r\n\t\r\n\t\t\t#animate {\r\n\t\t\t\tbackground: rgba(255, 255, 255, 0.2);\r\n\t\t\t\tcursor: pointer;\r\n\t\t\t\tborder: 0;\r\n\t\t\t\tborder-radius: 3px;\r\n\t\t\t\tbottom: 100px;\r\n\t\t\t\tleft: 50%;\r\n\t\t\t\toutline: 0;\r\n\t\t\t\tpadding: 10px 30px;\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttransform: translateX(-50%);\r\n\t\t\t}\r\n\t\r\n\t\t\t#animate:active {\r\n\t\t\t\tbackground: rgba(255, 255, 255, 0.1);\r\n\t\t\t}\r\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error-alert-animated") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "failureAnimationCircle",
    className: "cls-1",
    cx: 72.1,
    cy: 72.1,
    r: 68.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.5,
    y1: 43.5,
    x2: 100.6,
    y2: 100.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 100.6,
    y1: 43.5,
    x2: 43.5,
    y2: 100.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlertAnimatedTres);
export default __webpack_public_path__ + "static/media/error-alert-animated-tres.0cdfd8be.svg";
export { ForwardRef as ReactComponent };